// src/api/teamApi.ts
//
// TEAM-UX-1 — READ-ONLY. Membership authoring lives in Settings → Members
// (`platformMembersApi` → CRM BFF `/api/platform/*` → Central).
//
// The invite / role-update / remove mutations that used to live here hit
// the CRM-local `/api/team/*` routes, which wrote the `UserWorkspaceRole`
// projection. That made CRM a second writer of membership state Central
// already owns. Those routes were retired server-side; re-adding a
// mutation here would resurrect the duplicate authoring path.
//
// `getTeamMembers` stays: 22 call sites across web and mobile read the
// roster from it (tasks, compliance, telephony, work accountability,
// provider assignments, messaging) plus the /team performance page.

import { baseApi } from './baseApi';
import type { TeamMemberSummary } from '../types/api';

interface GetTeamParams {
  workspaceId?: string;
}

export const teamApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTeamMembers: builder.query<TeamMemberSummary[], GetTeamParams>({
      query: (params) => ({
        url: '/team',
        params: {
          ...(params.workspaceId && { workspaceId: params.workspaceId }),
        },
      }),
      providesTags: (result, error, { workspaceId }) =>
        result
          ? [
              ...result.map(({ userId }) => ({ type: 'Team' as const, id: userId })),
              { type: 'Team', id: workspaceId || 'LIST' },
            ]
          : [{ type: 'Team', id: workspaceId || 'LIST' }],
    }),
  }),
});

export const { useGetTeamMembersQuery } = teamApi;
